<template>
  <div v-if="onCheckout">
    <!-- Nome del socio al centro: assente se nessuno è loggato. -->
    <div v-if="kioskSession.userName" class="kcb-name">{{ kioskSession.userName }}</div>

    <button class="kcb-close" :disabled="busy" @click="closeCheckout"
            aria-label="Chiudi checkout">
      <span class="kcb-close__x">✕</span> Chiudi
      <span v-if="countdown !== null" class="kcb-close__timer" aria-live="off">{{ countdown }}s</span>
    </button>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { KIOSK_IDLE_WARNING_MS } from '@/config/kiosk'
import { kioskSession, paymentBusy } from '@/config/kioskSession'

const route = useRoute()
const router = useRouter()

const busy = computed(() => kioskSession.paymentActive || kioskSession.cardActive)

const onCheckout = computed(() => route.path.startsWith('/checkout'))

// Il conto alla rovescia compare solo negli ultimi KIOSK_IDLE_WARNING_MS, e non
// mentre il Cashmatic sta incassando (lì il timeout non scatta).
const countdown = computed(() => {
  const s = kioskSession.idleSecondsLeft
  if (s === null || paymentBusy()) return null
  return s <= KIOSK_IDLE_WARNING_MS / 1000 ? s : null
})

// La home ripulisce la sessione del socio (vedi KioskHome): uscire da qui chiude anche quella.
function closeCheckout () {
  if (paymentBusy()) return
  router.push({ path: '/kiosk' })
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@600&display=swap');

.kcb-name {
  position: fixed;
  top: 22px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9998;
  max-width: 40vw;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #fff;
  font-family: 'Montserrat', sans-serif;
  font-size: 1.25rem;
  font-weight: 600;
  pointer-events: none;
}

/* In alto a destra c'è la zona invisibile di 90×90 px dei 6 tap per la
   manutenzione (KioskAdminGate): il pulsante le sta accanto, non sopra. */
.kcb-close {
  position: fixed;
  top: 18px;
  right: 110px;
  z-index: 9998;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(255, 255, 255, 0.14);
  color: #fff;
  border: none;
  border-radius: 12px;
  padding: 12px 22px;
  font-family: 'Montserrat', sans-serif;
  font-size: 1.15rem;
  font-weight: 600;
  cursor: pointer;
}
.kcb-close:active { background: rgba(255, 255, 255, 0.28); }
.kcb-close[disabled] { opacity: 0.4; cursor: default; }
.kcb-close__timer {
  min-width: 2.6ch;
  padding: 2px 10px;
  border-radius: 999px;
  background: #ffc933;
  color: #2e348c;
  font-weight: 700;
  text-align: center;
}
</style>
